import FileUploadsRoutes from './file-uploads-routes';

export default FileUploadsRoutes;
